import React from 'react';

import BrandLogo from 'assets/images/BrandLogo';
import { StyledBox, StyledTypography } from './styled';
import EnvStatus from 'components/EnvStatus';

const MainLogo: React.FC = () => {
  return (
    <StyledBox>
      <BrandLogo />
      <StyledTypography>Sites and user management</StyledTypography>
      <EnvStatus />
    </StyledBox>
  );
};

export default MainLogo;
